import {
  LayoutDashboard,
  Activity,
  Siren,
  Bell,
  AlarmClock,
  Workflow,
  // Gauge — used by the temporarily-hidden Uptime nav item (re-add when restoring)
  type LucideIcon,
} from 'lucide-react';

export interface HealthcheckNavEntry {
  label: string;
  /** Path segment under `/services/healthcheck/:projectId` ('' = console root). */
  slug: string;
  icon: LucideIcon;
}

export interface HealthcheckNavGroup {
  heading?: string;
  items: HealthcheckNavEntry[];
}

/**
 * Monitoring console navigation. Slugs map 1:1 to the nested routes in
 * HealthcheckConsole. Rendered in the app's scope-driven `ContextualSidebar`.
 */
export const HEALTHCHECK_NAV_GROUPS: HealthcheckNavGroup[] = [
  {
    items: [
      { label: 'Dashboard', slug: '', icon: LayoutDashboard },
      { label: 'Monitors', slug: 'monitors', icon: Activity },
      // Temporarily hidden from the nav while under testing — re-enable to restore.
      // { label: 'Uptime', slug: 'kuma-uptime', icon: Gauge },
      { label: 'Incidents', slug: 'incidents', icon: Siren },
      { label: 'Notifications', slug: 'notifications', icon: Bell },
      { label: 'Alarms', slug: 'alarms', icon: AlarmClock },
      { label: 'Playbooks', slug: 'playbooks', icon: Workflow },
    ],
  },
];

/** Absolute href for a nav entry under the console base (`''` slug = base/root). */
export function hcHref(base: string, slug: string): string {
  return slug ? `${base}/${slug}` : base;
}

/** The active entry href for the current pathname (longest match wins). */
export function hcActiveId(base: string, pathname: string): string {
  const all = HEALTHCHECK_NAV_GROUPS.flatMap((g) => g.items);
  const matches = all
    .map((e) => hcHref(base, e.slug))
    .filter((href) => pathname === href || pathname.startsWith(`${href}/`))
    .sort((a, b) => b.length - a.length);
  return matches[0] ?? base;
}
